import { LOAD_FAVORITES, FAVORITE_CLUB, UNFAVORITE_CLUB, UNAUTHENTICATED } from "../actions";
import { Club } from "../types";

export const initialState = {
	favorites: null as Club[],
};

export type ClubsState = typeof initialState;

export default function(state = initialState, action) {
	switch (action.type) {
		case LOAD_FAVORITES: {
			const favorites = action.favorites;
			return { ...state, favorites };
		}

		case FAVORITE_CLUB: {
			let favorites = state.favorites;
			if (favorites === null) {
				favorites = [];
			}

			favorites.push(action.club);

			return { favorites: [...favorites] };
		}

		case UNFAVORITE_CLUB: {
			let favorites = state.favorites;
			if (favorites === null) {
				return state;
			}

			for (let i = 0; i < favorites.length; i++) {
				if (favorites[i].clubInfo.clubId === action.club.clubInfo.clubId) {
					favorites.splice(i, 1);
				}
			}

			return { favorites: [...favorites] };
		}

		case UNAUTHENTICATED: {
			return initialState;
		}

		default:
			return state;
	}
}
